import React, { Component } from "react";
import { connect } from "react-redux";
import Dashboard from "./DashboardCore";
import Widget from "./Widget";
import LineGraphCard from "./Widgets/LineGraphCard";
import BarChartCard from "./Widgets/BarChartCard";

import PieChartWithPaddingAngle from "./Widgets/PieChartWithPaddingAngle";
import Preloader from "../Preloader";
import Search from "./Search";
import DocumentSearchService from "../../services/DocumentSearch/DocumentSearchService";
import DashboardWidgetReportsService from "../../services/DocumentStore/DashboardWidgetReportsService";

const {
  inventoryTotals,
  physicalRecordsBreakdown,
  itemTypeByStatus,
  physicalRecordsDestructionOverview,
  physicalRecordsPendingDestructionOverview,
  physicalWorkOrderOverviewByType,
  workOrderSubmissionsForCurrentMonth,
  digitalStorageUsage,
} = DashboardWidgetReportsService;

const { physicalSearch } = DocumentSearchService;

const COLORS = [
  "#FF5200",
  "#4FBFD7",
  "#55BA8C",
  "#4FBFD7",
  "#00257B",
  "#9F9F9F",
  "#93D3B6",
  "#F6B12F",
  "#DEDEDE",
];

export class index extends Component {
  state = {
    isLoading: false,
    IsEnablePhysicalSearch: false,
    IsEnableDigitalSearch: false,
    Widgets: [],
  };
  handleError = (widgetKey) => {
    const widget = this.state.Widgets.find((f) => f.key === widgetKey);
    widget.component = (
      <div className="dashboard-error-context">
        {this.props._.ClientHub.IssueGettingDataLineOne}
        <br />
        {this.props._.ClientHub.IssueGettingDataLineTwo}
      </div>
    );
    this.setState({
      Widgets: [
        ...this.state.Widgets.filter((f) => f.key !== widgetKey),
        widget,
      ],
    });
  };

  async componentDidMount() {
    const monthName = this.props._.MonthNames[new Date().getMonth()];

    const user = this.props.User;
    const _ = this.props._;
    this.setState(
      {
        IsEnablePhysicalSearch: user.tr_employeeId,
        IsEnableDigitalSearch: user.portal_haspermission_OMNIDOX === "YES",
      },
      async () => {
        const widgets = [
          {
            key: "1",
            title: _.ClientHub.InventoryTotals,
            load: () => inventoryTotals(),
            render: (data) => (
              <PieChartWithPaddingAngle
                data={data}
                showTotal={false}
                COLORS={COLORS}
              />
            ),
          },
        ];
        if (this.state.IsEnablePhysicalSearch) {
          widgets.push({
            key: "2",
            title: _.ClientHub.PhysicalRecordBreakdown,
            load: () => physicalRecordsBreakdown(),
            render: (data) => (
              <PieChartWithPaddingAngle data={data} COLORS={COLORS} />
            ),
          });
          widgets.push({
            key: "4",
            title: _.ClientHub.ItemTypeByStatus,
            load: () => itemTypeByStatus(),
            render: (data) => <BarChartCard data={data} />,
          });
          widgets.push({
            key: "5",
            title: _.ClientHub.DestructionOverview,
            load: () => physicalRecordsDestructionOverview(),
            render: (data) => (
              <PieChartWithPaddingAngle
                data={data}
                COLORS={COLORS}
                showTotal={true}
              />
            ),
          });
          widgets.push({
            key: "6",
            title: _.ClientHub.PendingDestruction,
            load: () => physicalRecordsPendingDestructionOverview(),
            render: (data) => (
              <PieChartWithPaddingAngle
                data={data}
                COLORS={COLORS}
                showTotal={true}
              />
            ),
          });
          widgets.push({
            key: "7",
            title: _.ClientHub.WorkOrderType,
            load: () => physicalWorkOrderOverviewByType(),
            render: (data) => (
              <PieChartWithPaddingAngle
                data={data}
                COLORS={COLORS}
                showTotal={false}
              />
            ),
          });
          widgets.push({
            key: "8",
            title: _.ClientHub.WorkOrderSubmission + ": " + monthName,
            load: () => workOrderSubmissionsForCurrentMonth(),
            render: (data) => (
              <LineGraphCard data={data} strokeColor="#FF5200" />
            ),
          });
        }
        if (this.state.IsEnableDigitalSearch) {
          widgets.push({
            key: "3",
            title: _.ClientHub.DigitalStorageUsage + " " + monthName,
            load: () => digitalStorageUsage(),
            render: (data) => (
              <LineGraphCard data={data} strokeColor="#FF5200" />
            ),
          });
        }
        this.setState({ Widgets: widgets, isLoading: false });
        await Promise.all([
          widgets.forEach((widget) => {
            widget
              .load()
              .then((res) => {
                if (res && res.data) {
                  widget.component = widget.render(res.data);
                  this.setState({
                    Widgets: [
                      ...this.state.Widgets.filter((f) => f.key !== widget.key),
                      widget,
                    ],
                  });
                } else {
                  this.handleError(widget.key);
                }
              })
              .catch((err) => this.handleError(widget.key));
          }),
        ]);
      }
    );
  }

  searchTrData = (searchKey) => {
    this.setState({ isLoading: true });
    physicalSearch({
      pageSize: 10,
      pageNumber: 1,
      orderByItem: { orderBy: "ItemCode", orderType: "ASC" },
      selectedItemIds: [],
      searchText: searchKey,
    })
      .then((res) => {
        this.setState({ isLoading: false });
        if (res.searchResult === 1) {
          const host = window.location.hostname;
          let bridgeApp = "https://testbridge.oasisgroup.com/dhsrmweb";

          if (
            host === "clienthub.oasisgroup.com" ||
            host === "hub.omnidox5.com"
          ) {
            bridgeApp = "https://oasisbridge.oasisgroup.com/dhsrmweb";
          }

          const link = document.createElement("a");
          link.setAttribute(
            "href",
            `${bridgeApp}/index.html?${this.props.User["user-email"]}`
          );
          link.target = "_blank";
          link.click();
        }
      })
      .catch((err) => {
        this.setState({ isLoading: true });
      });
  };
  render() {
    const user = this.props.User;
    const _ = this.props._;
    return (
      <>
        {this.state.isLoading && <Preloader />}
        <div className="sectionWrapper reports-dashboard-page orange ">
          <div className="row h-100">
            <div className="col reports-dashboard-container">
              <h2
                className="reports-dashboard-header"
                // onClick={() => setOpenModel(true)}
              >
                {_.ClientHub.Dashboard}
              </h2>
              {user.tr_bypass === "Bridge" &&
                user.features &&
                user.features.length > 0 &&
                user.features.find((f) => f.featureType === 0) &&
                user.features.find((f) => f.featureType === 0).isEnabled && (
                  <Search search={this.searchTrData} />
                )}
              {this.state.Widgets.length > 0 && (
                <Dashboard>
                  {this.state.Widgets.sort(function (a, b) {
                    return a.key - b.key;
                  }).map((widget, index) => (
                    <Widget
                      key={index + 1}
                      Component={
                        widget.component ? widget.component : <Preloader />
                      }
                      icon={"icon-omni-Reports-Nav"}
                      title={widget.title}
                    />
                  ))}
                </Dashboard>
              )}
            </div>
          </div>

          {/* <Modal
          visible={openModel}
          closemodal={() => setOpenModel(false)}
          type="fadeIn"
        >
          <AddWidget setOpenModel={setOpenModel}></AddWidget>
        </Modal> */}
        </div>
      </>
    );
  }
}

export const mapStateToProps = ({ _, User }) => ({ _, User });

export default connect(mapStateToProps)(index);
